export default "__VITE_ASSET__CNOsSjO2__"